'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import type { Capability } from '../_lib/capabilities';
import { BackArrowIcon } from './icons';

/**
 * Launch Pad sub-bar: [← Back to Hub] · zone-tabs. Renders inside the
 * capability's section bar slot, replacing the 5-capability row.
 */
export function ZoneTabs({ capability }: { capability: Capability }) {
  const pathname = usePathname() ?? '/';

  return (
    <nav className="row-sections" aria-label={`${capability.label} zones`}>
      <Link href="/" className="back-to-hub" aria-label="Back to Hub">
        {BackArrowIcon}
        <span className="cap-context">
          <b>{capability.label}</b>
        </span>
      </Link>
      <div className="section-scroll" role="tablist">
        {capability.zones.map((zone) => {
          const active =
            pathname === zone.href ||
            (zone.href !== capability.href && pathname.startsWith(zone.href + '/'));
          return (
            <Link
              key={zone.id}
              href={zone.href}
              role="tab"
              aria-selected={active}
              className={`section-tab${active ? ' active' : ''}`}
            >
              {zone.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
